import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from "redux";
import ListView from "../common/ListView";
import {returnProduct, searchProductsSold} from "./actions";
import DateTimeDisplay from "../common/DateTimeDisplay";
import {getSuppliers} from "../Supplier/actions";
import {getBrands} from "../Brand/actions";
import {Select} from "antd";
import CorrectProductSoldModal from "./CorrectProductSoldModal";

const Option = Select.Option;

class ProductsSoldPage extends Component {
  static propTypes = {
    /* state */
    history: PropTypes.object.isRequired,
    salonId: PropTypes.string.isRequired,
    searching: PropTypes.bool.isRequired,
    pagination: PropTypes.object.isRequired,
    sorter: PropTypes.object.isRequired,
    results: PropTypes.array.isRequired,
    searchFilter: PropTypes.string.isRequired,
    suppliers: PropTypes.array.isRequired,
    brands: PropTypes.array.isRequired,
    /* actions */
    searchProductsSold: PropTypes.func.isRequired,
    getSuppliers: PropTypes.func.isRequired,
    getBrands: PropTypes.func.isRequired,
    returnProduct: PropTypes.func.isRequired,
  };

  state = {
    supplierId: null,
    brandId: null,
  };

  _modalRef = null;

  componentDidMount() {
    this._load().catch(console.error);
  }

  async _load() {
    const salonId = this.props.salonId;
    try {
      await this.props.getSuppliers({salonId});
    } catch (e) {
      console.error('failed fetching suppliers', e);
    }
    try {
      await this.props.getBrands({salonId});
    } catch (e) {
      console.error('failed fetching brands', e);
    }
  }

  _handleModalClose = () => setTimeout(() => this._listView.refresh(), 500);

  render() {
    const {
      salonId, searchProductsSold,
      searching, pagination, sorter, results, searchFilter,
      returnProduct,
    } = this.props;
    const {supplierId, brandId} = this.state;
    const columns = [
      {
        title: 'Sold At',
        dataIndex: 'soldAt',
        key: 'soldAt',
        fixed: 'left',
        sorter: true,
        render: (createdAt) => <DateTimeDisplay dateTime={createdAt}/>,
        width: 165
      },
      {
        title: 'Product',
        dataIndex: 'productDisplay',
        key: 'productDisplay',
        sorter: true,
      },
      {
        title: 'Supplier',
        dataIndex: 'supplierName',
        key: 'supplierName',
        sorter: true,
      },
      {
        title: 'Brand',
        dataIndex: 'brandName',
        key: 'brandName',
        sorter: true,
      },
      {
        title: 'SKU',
        dataIndex: 'sku',
        key: 'sku',
        sorter: true,
        width: 150
      },
      {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity',
        sorter: true,
        width: 120,
        render: (_, {quantity, returns}) => returns.length > 0
          ? returns.reduce((a, r, i) => {
            const prev = a[a.length - 1];
            a[a.length - 1] = <strike key={i}>&nbsp;{prev}&nbsp;</strike>;
            a.push(' ');
            a.push(prev - r.quantity);
            return a;
          }, [quantity])
          : quantity
      },
      {
        title: 'Actions',
        key: 'action',
        fixed: 'right',
        width: 90,
        render: (_, {transactionId, productId, productDisplay, sku, quantity, returnedQuantity}) => returnedQuantity >= quantity
          ? null
          : <a onClick={() => this._modalRef.open(transactionId, productId, productDisplay, sku, quantity)}>Correct</a>
      }
    ];
    return (
      <React.Fragment>
        <CorrectProductSoldModal
          ref={ref => this._modalRef = ref}
          returnProduct={returnProduct}
          onClose={this._handleModalClose}
        />
        <ListView
          ref={ref => this._listView = ref}
          title="Products Sold"
          searchPlaceholder="Search name and sku"
          loading={searching}
          columns={columns}
          dataSourceProvider={searchProductsSold}
          dataSource={results}
          pagination={pagination}
          filters={{salonId, supplierId: supplierId || undefined, brandId: brandId || undefined}}
          sorter={sorter}
          searchFilter={searchFilter}
          salonId={salonId}
          rowKey="transactionId"
        >
          <div style={{marginBottom: '1em'}}>
            {"Supplier "}
            <Select
              value={supplierId}
              onChange={supplierId => { this.setState({ supplierId }); window.setTimeout(() => this.listView.refresh(), 0); }}
              style={{width: 200}}
            >
              <Option key="NULL" value={null}>-- ALL --</Option>
              {this.props.suppliers.map(supplier => (
                <Option key={supplier.supplierId} value={supplier.supplierId}>{supplier.name}</Option>
              ))}
            </Select>
            {" Brand "}
            <Select
              value={brandId}
              onChange={brandId => { this.setState({ brandId }); window.setTimeout(() => this.listView.refresh(), 0); }}
              style={{width: 200}}
            >
              <Option key="NULL" value={null}>-- ALL --</Option>
              {this.props.brands.map(brand => (
                <Option key={brand.brandId} value={brand.brandId}>{brand.name}</Option>
              ))}
            </Select>
          </div>
        </ListView>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  salonId: state.salon.selectedSalonId,
  search: state.product.productsSoldSearch,
  searching: state.product.productsSoldSearch.searching,
  pagination: state.product.productsSoldSearch.pagination,
  sorter: state.product.productsSoldSearch.sorter,
  results: state.product.productsSoldSearch.results.map(item => ({...item, returnedQuantity: item.returns.reduce((a, r) => a + r.quantity, 0)})),
  searchFilter: state.product.productsSoldSearch.searchFilter,
  suppliers: state.supplier.suppliers,
  brands: state.brand.brands,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchProductsSold,
  getSuppliers,
  getBrands,
  returnProduct,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(ProductsSoldPage);



// WEBPACK FOOTER //
// ./src/Product/ProductsSoldPage.js